const data = [
  {
    catogeries: "phone",
    id: "1",
    name: "APPLE iPhone 12 Pro (Gold, 128 GB)",
    rating: "4.5",
    discription:
      "A14 Bionic rockets past every other smartphone chip. The Pro camera system takes low-light photography to the next level — with an even bigger jump on iPhone 12 Pro Max. And Ceramic Shield delivers four times better drop performance. Let’s see what this thing can do.",
    price: "₹119900",

    image: [
      "https://rukminim1.flixcart.com/image/416/416/kg8avm80/mobile/s/9/w/apple-iphone-12-pro-dummyapplefsn-original-imafwgbr37gm57f7.jpeg?q=70",
      "https://rukminim1.flixcart.com/image/416/416/kg8avm80/mobile/s/9/w/apple-iphone-12-pro-dummyapplefsn-original-imafwgbrnpyygbv9.jpeg?q=70",
      "https://rukminim1.flixcart.com/image/416/416/kg8avm80/mobile/s/9/w/apple-iphone-12-pro-dummyapplefsn-original-imafwgbrpksqr8zu.jpeg?q=70",
      "https://rukminim1.flixcart.com/image/416/416/kg8avm80/mobile/s/9/w/apple-iphone-12-pro-dummyapplefsn-original-imafwgbrgcctfysm.jpeg?q=70",
      "https://rukminim1.flixcart.com/image/416/416/kg8avm80/mobile/s/9/w/apple-iphone-12-pro-dummyapplefsn-original-imafwgbrqwsxbmuh.jpeg?q=70",
    ],
    review: [
      "Performance was blazing quick too. Even with all its bells and whistles, FunTouch OS ran smoothly and was easy to master. I also found the biometrics to be very reliable, be it the fingerprint sensor or face recognition. Videos looked great on the phone's display, especially HDR content.",
      "One of the best looking phone in the market right now with a decent performance jump from 11 pro. Camera is excellent and the display is quite responsive and sharp. Only issue is it does not have a higher refresh rate and the battery life is average.",
      "I have upgraded from Android to iOS for the first time with the IPhone 12 Pro. And the experience is very much satisfactory. The new A14 bionic processor is very fast. The boxy design is what I liked the most. The camera and display are top notch. Night mode photography is excellent. Worth upgrading from Android to iOS .",
      "Awesome! Just made an upgrade from X, worth every single penny spent on it, the camera is just too superb, be it the selfie cam or the main rear cam, the goodness it takes the picture is just beyond words, no smart phone can beat it atm! However, the battery life tends to be on the shorter side, that’s the only con that I can’t think up of now.",
    ],
    
  },

  {
    catogeries: "phone",
    id: "2",
    name: "realme Narzo 30 5G (Racing Blue, 128 GB)",
    rating: "4.5",
    discription:
      "High-speed internet, smooth gaming, and stunning photos, the realme Narzo Pro 5G is a power-packed smartphone for impressive performance. This smartphone features the 5G Technology for high-speed web browsing, the Dimensity 700 5G Processor for smooth gaming, and a 5000 mAh Massive Battery for hours of uninterrupted performance.",
    price: "₹15,990",

    image: [
      "https://rukminim1.flixcart.com/image/416/416/kq18n0w0/mobile/d/l/f/narzo-30-5g-rmx3242-realme-original-imag45yjdkgxddvh.jpeg?q=70",
      "https://rukminim1.flixcart.com/image/416/416/kq18n0w0/mobile/8/u/w/narzo-30-5g-rmx3242-realme-original-imag45yjxdvfkrws.jpeg?q=70",
      "https://rukminim1.flixcart.com/image/416/416/kq18n0w0/mobile/j/s/o/narzo-30-5g-rmx3242-realme-original-imag45yjnhhqy4gv.jpeg?q=70",
      "https://rukminim1.flixcart.com/image/416/416/kq18n0w0/mobile/o/l/w/narzo-30-5g-rmx3242-realme-original-imag45yjxqhvfzjn.jpeg?q=70",
    ],
    review: [
      `First the phone design is awesome. And in this price it is the best 6gb ram 5G phone.
      Pros:
      1. Good battery life
      2. Smooth refresh rate
      3. Design
      4. Additional ram of 5gb features
      5. 5G phone with most number of bands in India ri8 now.
      
      
      Cons:
      1. Display LCD not up to the mark
      2. Camera is better but ok
      3. 18W charger`,
      "Really great phone , it's worth for money , good display , good battery backup , really a good phone ❤️👏👍",
      `super camera qulity...i use realme phon first time but i m feel so much happy and satisfaide with product..

      battery life is good and phon work also fast...
      
      and specily thenks to flipcart..`,
    ],
  },

  {
    catogeries: "phone",
    id: "3",
    name: "POCO M3 (Power Black, 64 GB)",
    rating: "4.5",
    discription:
      "High-speed internet, smooth gaming, and stunning photos, the realme Narzo Pro 5G is a power-packed smartphone for impressive performance. This smartphone features the 5G Technology for high-speed web browsing, the Dimensity 700 5G Processor for smooth gaming, and a 5000 mAh Massive Battery for hours of uninterrupted performance.",
    price: "₹11,499",

    image: [
      "https://rukminim1.flixcart.com/image/416/416/kklhbbk0/mobile/m/s/f/m3-mzb0879in-poco-original-imafzxf686qtxq2x.jpeg?q=70",
      "https://rukminim1.flixcart.com/image/416/416/kkoc70w0/mobile/l/5/5/m3-mzb0879in-poco-original-imafzyx8dkyvjyt5.jpeg?q=70",
      "https://rukminim1.flixcart.com/image/416/416/kklhbbk0/mobile/w/k/2/m3-mzb0879in-poco-original-imafzxf65mefhdrr.jpeg?q=70",
      "https://rukminim1.flixcart.com/image/416/416/kklhbbk0/mobile/e/e/d/m3-mzb0879in-poco-original-imafzxf6e5mvhqpm.jpeg?q=70",
    ],
    review: [
      `Good mobile poco m3
      Pros:
      Fullhd display,
      smooth tocuh response,
      6000mah battery,
      avarage weight,
      back disign amazing,
      no heatting issue,
      decent back camera
      Excellent sound quality it's very clear
      Cons:
      front camara not take a clear picture,
      Charging time to long .50% charging time 1 hour 35 minutes.
      Ovarall the price segment this mobile good`,
      "Sound quality super 3 type sound but camera selfie camera is not good &Back camera is normally or value of money. Totally side & angel to seen to parfect",
      `One word review " Value for Money"
      It has the potential to be a nice casual daily driver
      Speakers are loud...like seriously loud.
      Screen size is good
      Though being a LCD screen it produces decent colours. For the price at which it comes that more than enough.
      Camera is neither the best nor the worst, it's quite good for this price point.
      6000 mA battery 🔋👍🏻
      Though it comes with a lot of bloatware but you can just uninstall most of them (excluding system apps)
      Finally the Verdict is that it's a good budget smartphone`,
    ],
  },

  {
    catogeries: "phone",
    id: "4",
    name: "MOTOROLA G60 (Dynamic Gray, 128 GB)",
    rating: "4.5",
    discription:
      "The moto g60 enables you to capture spectacular selfies wherever you are, thanks to its 32 MP selfie camera, the Quad Pixel technology, and LED flash. Thanks to the smooth 17.2 cm (6.8) HDR10 Display, you can enjoy a lifelike experience while streaming content, gaming, and more. And, thanks to the powerful 6000 mAh battery, you can enjoy using your mobile phone for all that you need, without any low-battery interruptions for a long time.",
    price: "₹17,999",

    image: [
      "https://rukminim1.flixcart.com/image/416/416/knoxnrk0/mobile/g/1/j/g60-panb0000in-panb0016in-panb0012in-panb0014in-motorola-original-imag2aq9v8hzetbn.jpeg?q=70",
      "https://rukminim1.flixcart.com/image/416/416/kolsscw0/mobile/u/o/z/g60-panb0000in-panb0016in-panb0012in-panb0014in-motorola-original-imag3f57r8v8p7q5.jpeg?q=70",
      "https://rukminim1.flixcart.com/image/416/416/knoxnrk0/mobile/h/c/a/g60-panb0000in-panb0016in-panb0012in-panb0014in-motorola-original-imag2aq9j5czsghh.jpeg?q=70",
      "https://rukminim1.flixcart.com/image/416/416/knoxnrk0/mobile/i/5/z/g60-panb0000in-panb0016in-panb0012in-panb0014in-motorola-original-imag2aq9zhcmnnym.jpeg?q=70",
    ],
    review: [
      `1.Very Smooth user interface.
      2. Gives you easily Two Days of battery backup with average use.
      3. Hepatic feedback too good.
      4. In this price range Rear camera is Above average. Hope it should be improve in future updates. & Front camera perform very well.
      5. In hand feel is little bulky, it feel heavier than other phone due to its big 6000 mah battery
      6. Display size is very big ( 6.8 inches ) & bright.
      7. Voice call quality is very good & clear.
      8. Notification LED light is missing, but Previous Motorola phones have led notification light.
      9. You will definitely love the gesture controls of this phone.
      10. It is splash proof & water repellent design.
      
      Over all this phone is value for money
      Go for it ...`,
      "Best phone in budget. Working very smoothly. Touch quality is awesome. Display is also very nice. Battery of the phone is very good only camera part is not so good as expected some updates are needed in camera rest all the things are the best.",
      `Product is worth of money. Performance of this is very smooth. I love it usually m using Motorola smart phone but this one is best.`,
    ],
  },

  {
    catogeries: "phone",
    id: "5",
    name: "Mi 11X (Lunar White, 128 GB)",
    rating: "4.2",
    discription:
      "The Mi 11X from Xiaomi is the most affordable of three new models in the Mi 11 family. It's priced a bit lower than the Mi 10T but offers plenty of updated features, most notably its Qualcomm Snapdragon 870 SoC which is only one step below the current flagship level. ",
    price: "₹27,990",
    image: [
      "https://rukminim1.flixcart.com/image/416/416/kp78e4w0/mobile/b/2/u/11x-11x-mi-original-imag3hqsshfzpv4u.jpeg?q=70",
      "https://rukminim1.flixcart.com/image/416/416/ko8xtow0/mobile/0/t/7/m2012k11ai-11x-redmi-original-imag2qsbpgar8sfd.jpeg?q=70",
      "https://rukminim1.flixcart.com/image/416/416/kod858w0/mobile/0/m/5/11x-pro-11x-pro-mi-original-imag2tzmhwzmf66y.jpeg?q=70",
      "https://rukminim1.flixcart.com/image/416/416/ko8xtow0/mobile/o/4/b/m2012k11ai-11x-redmi-original-imag2qsbpbk6vyg3.jpeg?q=70",
    ],
    review: [
      "Performance was blazing quick too. Even with all its bells and whistles, FunTouch OS ran smoothly and was easy to master. I also found the biometrics to be very reliable, be it the fingerprint sensor or face recognition. Videos looked great on the phone's display, especially HDR content. ",
      "I say about this mobile only wow wow and wow it's performing god level performance and this mobile look so cool very slim and light weight mobile display quality is 10/10 battery life is so better it's battery perform like 6000 mah of ips display mobile amoled is very good working Iblove it❤️❤️❤️❤️❤️❤️❤️❤️❤️❤️❤️❤️❤️❤️❤️❤️❤️❤️❤️❤️❤️❤️❤️❤️❤️❤️❤️❤️❤️❤️❤️❤️❤️❤️❤️❤️❤️❤️❤️❤️❤️❤️❤️❤️❤️❤️❤️❤️❤️❤️❤️❤️😍😍😍😍",
      "Good phone...But not a good camera..Usually redmi phones not good in camera quality but it's ok...120 heartz refresh rate with AMO LED display give perfect display and best batter backup",
    ],
  },
  {
    catogeries: "phone",
    name: "OPPO Reno6 Pro 5G (Aurora, 256 GB)",
    id: "6",
    rating: "4.5",
    discription:
      "The OPPO Reno6 Pro 5G is not only easy on the eyes but also equipped with innovative features. The X-axis Linear Motor ensures immersive viewing and usage. With an ultra-slim body and lightweight construction, you can easily hold it during extended usage. You can replicate the appeal of some of your favourite images in a single click with the AI Palette feature. And, you can enjoy long-lasting usage with its 4500 mAh battery.",
    price: "₹55,900",
    image: [
      "https://rukminim1.flixcart.com/image/416/416/kr2e3680/mobile/l/p/k/reno6-pro-5g-cph2249-oppo-original-imag4xpc6mc62mzq.jpeg?q=70",
      "https://rukminim1.flixcart.com/image/416/416/kr2e3680/mobile/k/u/u/reno6-pro-5g-cph2249-oppo-original-imag4xpcvxzzyzgz.jpeg?q=70",
      "https://rukminim1.flixcart.com/image/416/416/kr2e3680/mobile/i/c/l/reno6-pro-5g-cph2249-oppo-original-imag4xpchmrsqdru.jpeg?q=70",
      "https://rukminim1.flixcart.com/image/416/416/kr2e3680/mobile/r/h/1/reno6-pro-5g-cph2249-oppo-original-imag4xpcbhkmzecp.jpeg?q=70",
    ],
    review: [
      "Performance was blazing quick too. Even with all its bells and whistles, FunTouch OS ran smoothly and was easy to master. I also found the biometrics to be very reliable, be it the fingerprint sensor or face recognition. Videos looked great on the phone's display, especially HDR content.",
      `It's a marvel from Oppo.. Stellar black one is just superb and the device is an all-rounder. Stunning looks and superb performance.
    Pros:
    Great looks
    Stunning curved oled display
    Great rear cams
    Super speed and smooth performance
    Dolby Atmos sound clarity is perfect
    Superb Call clarity and network reception
    In hand feel is supercool
    Ultrafast charging`,
      "This is a Great phone, nice camera, Good Battery backup, Fast Charging and beautiful design. I Love 😘😘 it",
    ],
  },
  {
    catogeries: "phone",
    id: "7",
    name: "realme 8 Pro (Infinite Black, 128 GB)",
    rating: "4.2",
    discription:
      "The realme 8 Pro features a Tilt-shift mode and the Tilt-shift Time Lapse video so that you can add a creative perspective to the content that you create. Thanks to the Super AMOLED Display, your favourite movies, games, and more are more bright and vivid on screen. And, thanks to the 4500 mAh battery, you can stream content, game, and more without worrying about recharging your phone.",
    price: "₹19,999",
    image: [
      "https://rukminim1.flixcart.com/image/416/416/kmmcrrk0/mobile/5/w/u/8-pro-rmx3081-realme-original-imagfgpgcxyjufz3.jpeg?q=70",
      "https://rukminim1.flixcart.com/image/416/416/kmmcrrk0/mobile/i/5/l/8-pro-rmx3081-realme-original-imagfgpgecfv3rng.jpeg?q=70",
      "https://rukminim1.flixcart.com/image/416/416/kmmcrrk0/mobile/e/z/b/8-pro-rmx3081-realme-original-imagfgpgvnmggnzd.jpeg?q=70",
      "https://rukminim1.flixcart.com/image/416/416/kmmcrrk0/mobile/u/z/r/8-pro-rmx3081-realme-original-imagfgpgedksupyf.jpeg?q=70",
    ],
    review: [
      "Old concept... realme 7 pro has same 720 g processor .yes 720g is very capable but using it again and again is not good but yes camera is very good even in 20x zoom images are super good and one thing more narzo 30 pro has 5g connectivity but this hadnt so ya 5g should be there",
      "Not a worth buy considering the competetions. A 90hz refresh rate and 732g processor would have given a better competetion and decent buy!!",
      "Super Mobile. I like so much. RAM is good. Camera is amazing. Battery charging speed excellent. Within 45min it will be full from 10% of battery. Only thing, the battery came down little fastly. It's not coming one day with Internet. With internet it's coming around 12 to 15 hrs. Totally very super mobile.",
    ],
  },
  {
    catogeries: "phone",
    id: "8",
    name: "Google Pixel 4a (Just Black, 128 GB)",
    rating: "4.1",
    discription:
      "The Google Pixel 4a is more than just another smartphone for your tasks! Its HDR+ will help you take stunning photos. The Night Sight mode with astrophotography is just what you need to click those stunning images of the star-lit skies you have been meaning to capture. This phone also features apps such as the Pixel Recorder app that transcribes speech automatically.",
    price: "₹31,999",
    image: [
      "https://rukminim1.flixcart.com/image/416/416/kflftzk0/mobile/h/q/u/google-pixel-4a-ga02099-in-original-imafwyzmnfxzmv5q.jpeg?q=70",
      "https://rukminim1.flixcart.com/image/416/416/kflftzk0/mobile/h/q/u/google-pixel-4a-ga02099-in-original-imafwyzmyq7m3unr.jpeg?q=70",
      "https://rukminim1.flixcart.com/image/416/416/kflftzk0/mobile/h/q/u/google-pixel-4a-ga02099-in-original-imafwyzn6c2yfgcb.jpeg?q=70",
      "https://rukminim1.flixcart.com/image/416/416/kflftzk0/mobile/h/q/u/google-pixel-4a-ga02099-in-original-imafwyznjqayzp2f.jpeg?q=70",
    ],
    review: [
      "if you are a classic compaq size phone lover this is definatly for you..i use it on daily basis social media, netflix, prime.. not for heavy game users. battery is upto mark for my use purpose.. camera is Worth the wait.. sharpness of every image is amazing.. night sight is a great feature.. i love the size and light weight. no bloating, heating issue yet faced",
      "Compact size, butter smooth performance, timely updates, a day long battery life with 6-7 hours of SOT and awesome camera. The night sight and astrophotography mode is killer. It's complete value for money package. Love it.",
      `One of the best smartphones of 2020 with reasonable price
    Works smooth as butter
    Camera is undoubtedly the best in prices segment or say any smartphone camera.
    Haptics are awesome
    Battery may need sometime to give you a full day of use as adaptive battery software takes time to learn the way you use the apps and phone
    Size and built quality are gonna impress you when you see it.
    Charging speed is quite fast.
    Overall the best android experience you can ever imagine.`,
    ],
  },

  {
    catogeries: "phone",
    id: "9",
    name: "SAMSUNG Galaxy A52 (Awesome Blue, 128 GB)",
    rating: "4.3",
    discription:
      "Bring home the Samsung Galaxy A52 smartphone to enjoy viewing sharp visuals, click clear images, record stable videos, and do more. Its rear camera setup, with OIS, helps you capture clear shots. While its 16.40 cm (6.5) FHD+ Super AMOLED display delivers vivid visuals, the Eye Comfort Shield ensures reduced blue light emissions, thereby preventing eye strain.",
    price: "₹27,999",
    image: [
      "https://rukminim1.flixcart.com/image/416/416/kmf7ki80/mobile/s/z/a/galaxy-a52-sm-a525fzbgins-samsung-original-imagfb4xdvtk8zzb.jpeg?q=70",
      "https://rukminim1.flixcart.com/image/416/416/kmf7ki80/mobile/1/r/s/galaxy-a52-sm-a525fzbgins-samsung-original-imagfb4xs5wtfmpm.jpeg?q=70",
      "https://rukminim1.flixcart.com/image/416/416/kmf7ki80/mobile/s/d/i/galaxy-a52-sm-a525fzbgins-samsung-original-imagfb4xyymq9gjw.jpeg?q=70",
      "https://rukminim1.flixcart.com/image/416/416/kmf7ki80/mobile/t/0/n/galaxy-a52-sm-a525fzbgins-samsung-original-imagfb4xczdhwwjn.jpeg?q=70",
    ],
    review: [
      "Good one. Nice camera. battery will last for a day. Good network reception. Update after 7 days of usage: Absolutely great phone. The camera great.",
      "Loved the design, quality, performance, feels rich while handling, and really appreciate that samsung had improved a lot for the user experience. E.g. performance, battery management has been improved a lot. Feels premium device. Easy and Smooth interface. I loved 😍it and would recommend to my friends and family!",
      "Finally Samsung brings an updated version of Galaxy A series which was one of the most selling mobile last year. As of now performance wise it's very much impressive. A52 feels good in hand and looks premium. No lag,display & camera quality is very good on this price category. Forget about Pixel and One plus here is the 8 GB varient which is definitely a value for money product 💯🤘",
    ],
  },

  {
    catogeries: "phone",
    id: "10",
    name: "SAMSUNG Galaxy F12 (Celestial Black, 64 GB)",
    rating: "4.5",
    discription:
      "The Samsung Galaxy F12 features a stylish design and innovative features so that you can enjoy using the mobile phone for all that you need. Thanks to its 6000 mAh battery, you will have a blast using your phone for a long time while you stream content and much more. It provides surround sound with Dolby Atmos so that you can delve into a world of rich music. And, it’s equipped with features that ensure the protection of your mobile phone.",
    price: "₹20900",
    image: [
      "https://rukminim1.flixcart.com/image/416/416/kn22m4w0/mobile/6/o/e/galaxy-f12-sm-f127gzkgins-samsung-original-imagftmhuqq3arbg.jpeg?q=70",
      "https://rukminim1.flixcart.com/image/416/416/kn22m4w0/mobile/l/y/w/galaxy-f12-sm-f127gzkgins-samsung-original-imagftmhwjx38zzs.jpeg?q=70",
      "https://rukminim1.flixcart.com/image/416/416/kn22m4w0/mobile/h/y/s/galaxy-f12-sm-f127gzkgins-samsung-original-imagftmhhvhmeqyb.jpeg?q=70",
    ],
    review: [
      "Performance was blazing quick too. Even with all its bells and whistles, FunTouch OS ran smoothly and was easy to master. I also found the biometrics to be very reliable, be it the fingerprint sensor or face recognition. Videos looked great on the phone's display, especially HDR content. ",
      "Best Samsung phone in this price range.Good battery back up.Decent Display.Fast fingerprint sensor.Rear camera quality is good.front camera is not up to the mark.90 Hz refresh rate is good.Good user interface.updated to one ui 3.1.there are some pre installed apps which can only be disabled.sound quality is low comparing with other smartphones in same price segment.using in low screen bightness noticed screen flickering.",
      "First I would like to thank you Flipkart for fastest delivery and yah the delivery guy is so cooperative and helpful. Samsung phones are always best in performance and this one is also affordable and awesome phone",
    ],
  },
  {
    catogeries: "Electronics",
    id: "11",
    name: "HP Chromebook 14a-na0002TU Laptop ",
    rating: "4.5",
    discription:
      "Celeron N4020/4GB/64GB SSD/Chrome OS/Integrated Graphics, Ceremic White, 35.6 cm (14 inch)",
    price: "₹27,490",

    image: [
      "https://m.media-amazon.com/images/I/61Gnrgw0mrL._SL1080_.jpg",
      "https://m.media-amazon.com/images/I/611IOLjs6CL._SL1080_.jpg",
      "https://m.media-amazon.com/images/I/61yZ-ylmF2L._SL1080_.jpg",
      "https://m.media-amazon.com/images/I/61ublRRxJeL._SL1080_.jpg",
    ],

    review: [
      "Performance was blazing quick too. Even with all its bells and whistles, FunTouch OS ran smoothly and was easy to master. I also found the biometrics to be very reliable, be it the fingerprint sensor or face recognition. Videos looked great on the phone's display, especially HDR content. ",
      "amazing..product nice fast delivery..thankyou flipkart",
      "Great picture quality, easy to setup. Simply Mindblowing",
    ],
  },

  {
    catogeries: "Electronics",
    id: "12",
    name: "Canon EOS 3000D DSLR Camera 1 Camera Body, 18 - 55 mm Lens  (Black) ",
    rating: "4.3",
    discription:
      "Self-Timer | Type C and Mini HDMI, |9 Auto Focus Points | 35x Optical Zoom., Effective Pixels: 18 MP APS-C CMOS sensor-which is 25 times larger than a typical Smartphone sensor., WiFi | Full HD | Video Recording at 1080 p on 30fps.",
    price: "₹27,955",

    image: [
      "https://rukminim1.flixcart.com/image/416/416/jfbfde80/camera/n/r/n/canon-eos-eos-3000d-dslr-original-imaf3t5h9yuyc5zu.jpeg?q=70",
      "https://rukminim1.flixcart.com/image/416/416/jfbfde80/camera/n/r/n/canon-eos-eos-3000d-dslr-original-imaf3t5hmepevckd.jpeg?q=70",
      "https://rukminim1.flixcart.com/image/416/416/jfbfde80/camera/n/r/n/canon-eos-eos-3000d-dslr-original-imaf3t5hagaafttz.jpeg?q=70",
      "https://rukminim1.flixcart.com/image/416/416/jfbfde80/camera/n/r/n/canon-eos-3000d-original-imaf3t5hjrz6zzzc.jpeg?q=70",
    ],

    review: [
      "product really great . I am totally sctified this product .really good camera for beggner .but flash button was missing that is not good .and capture is 18 mp wasn't good I was hopeed it will be 24 mp . it is also missing .n everything is good ",
      "amazing..product nice fast Satisfied with the product.. Its a really good for all who wants to learn photography its a gem and love.... Go for itt....10/10..thankyou flipkart",
      "Worth more than the amount. Best DSLR for a good beginner. Friendly camera. Love it. ❤️ Extremely good with canon 50mm f1.8 STM lens.",
    ],
  },

  {
    catogeries: "Electronics",
    id: "13",
    name: "HP 27 inch Full HD LED Backlit IPS Panel Monitor (27m)  33000 mAh Power Bank  (Blue, Lithium-ion)",
    rating: "4.2",
    discription:
      "(Frameless, Response Time: 5 ms, 60 Hz Refresh Rate) N4020/4GB/64GB SSD/Chrome OS/Integrated Graphics, Ceremic White, 35.6 cm (14 inch)",
    price: "₹15,549",

    image: [
      "https://rukminim1.flixcart.com/image/416/416/kbcjpu80/monitor/a/s/e/27m-3wl49aa-hp-original-imafsputczcjgktz.jpeg?q=70",
      "https://rukminim1.flixcart.com/image/416/416/kbcjpu80/monitor/a/s/e/27m-3wl49aa-hp-original-imafsputpg8sgkb4.jpeg?q=70    ",
      "https://rukminim1.flixcart.com/image/416/416/kbcjpu80/monitor/a/s/e/27m-3wl49aa-hp-original-imafsput8zgebmhy.jpeg?q=70    ",
      "https://rukminim1.flixcart.com/image/416/416/kbcjpu80/monitor/a/s/e/27m-3wl49aa-hp-original-imafsputt73tfvxj.jpeg?q=70",
    ],

    review: [
      "I simply loved it. I bought this product for my office work and if you are planning to use for WFH then it is one of the best product available. ",
      "Love this monitor!",
      "Been using this monitor from a month. It's huge screen helps, especially for people who are working from home. Great clarity and good looks.",
    ],
  },

  {
    catogeries: "Electronics",
    id: "14",
    name: "Worricow Deep Bass Wireless Portable Bluetooth Mp3 Headphone MP3 Player ",
    rating: "4.0",
    discription:
      "WORRICOW Presents P-47 HEADPHONE:-With a combination of great sound, ergonomic design, and modern appeal the headphones are a great fit for anyone who wants to enjoy their tunes. Wear your headphones all day without discomfort. Alter the headband to fit perfectly and securely on your head.",
    price: "₹474",

    image: [
      "https://rukminim1.flixcart.com/image/416/416/kkbh8cw0/audioplayer/k/d/m/deep-bass-wireless-portable-bluetooth-mp3-headphone-worricow-original-imafzzwggbyf8dwv.jpeg?q=70",
      "https://rukminim1.flixcart.com/image/416/416/kkbh8cw0/audioplayer/d/2/4/wireless-portable-bluetooth-mp3-headphone-worricow-original-imafzzw2xwy7htsk.jpeg?q=70",
      "https://rukminim1.flixcart.com/image/416/416/kkbh8cw0/audioplayer/9/o/x/high-quality-wireless-portable-bluetooth-mp3-headphone-worricow-original-imafzzw8zdcrjden.jpeg?q=70",
      "https://rukminim1.flixcart.com/image/416/416/kkbh8cw0/audioplayer/s/d/7/deep-bass-wireless-portable-bluetooth-mp3-headphone-worricow-original-imafzzwgahnqxax2.jpeg?q=70",
    ],

    review: [
      "PROS: best in budget, with a good bass most loved thing is 🔋 backup. 1hour charge gives minimum 10 ✌️🎧 enjoyment Magnetic attaching helps more to improve battery life more😍 ",
      "nice very beautiful Realme bud Very good sound",
      "bass quality very nice battery backup good",
    ],
  },

  {
    catogeries: "Electronics",
    id: "15",
    name: "realme Buds Wireless Bluetooth Headset  (Yellow, In the Ear) ",
    rating: "4.9",
    discription: "With Mic:Yes,Bluetooth version: 5 Wireless range: 10 m",
    price: "₹1,799",

    image: [
      "https://rukminim1.flixcart.com/image/416/416/k2arbm80/headphone/c/v/m/realme-buds-original-imafhzf2yxgn8hyh.jpeg?q=70",
      "https://rukminim1.flixcart.com/image/416/416/k2arbm80/headphone/c/v/m/realme-buds-original-imafhzf2prxthhyv.jpeg?q=70",
      "https://rukminim1.flixcart.com/image/416/416/k2arbm80/headphone/c/v/m/realme-buds-original-imafhzf2f6zfhhfj.jpeg?q=70",
      "https://rukminim1.flixcart.com/image/416/416/k2arbm80/headphone/c/v/m/realme-buds-original-imafhzf2bfzajtgw.jpeg?q=70",
    ],

    review: [
      "in love with this the auto turn off when magnet sticks is very handy and saves battery audio quality good...balances between the highs and the lows good mids also ",
      "i have used skullcandy inkd as well as boat rockerz 225 as a comparison, skullcandy handles every frequencies without any distortion, gives a great quality and feel to the audio boat adds bass to the normal audio which makes it distorted at large volumes and long usage times coming to realme, it is far beyond boat in terms of audio...",
      "I would like to thank Flipkart for delivered this product with in time ... It's really amazing .. nice battery backup and inbuilt quality... But you need to improve bass quality .. thankyou ..",
    ],
  },
  {
    catogeries: "Electronics",
    id: "16",
    name: "NLG-428-BLUE-BLU All Blue Boys Series Analog Watch - For Men ",
    rating: "3.9",
    discription:
      "Celeron N4020/4GB/64GB SSD/Chrome OS/Integrated Graphics, Ceremic White, 35.6 cm (14 inch)",
    price: "₹27,490",

    image: [
      "https://rukminim1.flixcart.com/image/880/1056/kpodocw0/watch/p/l/t/anlg-428-blue-blu-analogue-original-imag3uxbhfkyhahf.jpeg?q=50",
      "https://rukminim1.flixcart.com/image/880/1056/kpodocw0/watch/w/4/a/anlg-428-blue-blu-analogue-original-imag3uxb2rthjhhh.jpeg?q=50 ",
      "https://rukminim1.flixcart.com/image/880/1056/kpodocw0/watch/1/i/q/anlg-428-blue-blu-analogue-original-imag3uxbszhbfbpu.jpeg?q=50",
      "https://rukminim1.flixcart.com/image/880/1056/kkfrjww0/watch/k/g/u/anlg-450-blue-brwn-dd-analogue-original-imafzsknpjt7q8aw.jpeg?q=50",
    ],

    review: [
      "Very nice and elegant watch. Really very osm. Jst loved it. It's quality is also great ",
      "Nice product good quality and nice packing You must buy this I loved this product Delivery was one day late to the given time",
      "Thank you filpkart it's fast delivery this watch also like beautiful and look is very impressive thank you...😘😘",
    ],
  },

  {
    catogeries: "Electronics",
    id: "18",
    name: "Epson L3100 Multi-function Color Printer  (Black, Ink Tank) ",
    rating: "4.6",
    discription:
      "Similar features as Epson L3110, Epson L3101 printer Printer Type - Ink Tank; Functionality - All-in-One (Print, Scan, Copy) , Scanner type - Flatbed; Printer Output",
    price: "₹11,199",

    image: [
      "https://rukminim1.flixcart.com/image/416/416/k0flmkw0/printer/h/d/h/epson-ecotank-l3100-l3100-original-imafk4ubnbz47tzq.jpeg?q=70",
      "https://rukminim1.flixcart.com/image/416/416/k0flmkw0/printer/h/d/h/epson-ecotank-l3100-l3100-original-imafk4ubsuaeeak9.jpeg?q=70",
      "https://rukminim1.flixcart.com/image/416/416/k0flmkw0/printer/h/d/h/epson-ecotank-l3100-l3100-original-imafk4ubypczkzy2.jpeg?q=70",
      "https://rukminim1.flixcart.com/image/416/416/k0flmkw0/printer/h/d/h/epson-ecotank-l3100-l3100-original-imafk4ubg8pbxeyp.jpeg?q=70",
    ],

    review: [
      "Printer Is Nice.* Quality Is Awesome. * High Quality Printing Is Very Slow. ",
      "You Can't Find This Printer's Driver On Internet. So Please Install Only DVD Drivers. * Use Photoshop For Photo Printing For Accurate Quality.* Printer Has Very Light Weight.",
      "Fpr Its Proper Care You Have To Cover It With Any Cloth On Its Idle Time. * Print Atleast One Color Print High Or Normal Dail...",
    ],
  },
  {
    catogeries: "fashion",
    id: "70",
    name: "DUDEME Java Developer | Geek Half Sleeve T Shirt for Men | Coding T Shirt for Coders",
    rating: "4.7",
    discription:
      "100% Combed Cotton DudeMe's combed cotton t-shirts are softer and stronger than regular cotton t-shirts. The cottons we use are made by further treating it after it's been picked, then spun into yarn to remove short fibers, which are prone to breakage. This process helps us deliver the best quality t-shirts without impurities or short protruding threads.",
    price: "₹569",
    image: [
      "https://m.media-amazon.com/images/I/510tKClQmzL._UL1080_.jpg",
      "https://m.media-amazon.com/images/I/51HHKHy69HL._UL1080_.jpg",
      "https://m.media-amazon.com/images/I/514lnA2H4vL._UL1080_.jpg",
      "https://m.media-amazon.com/images/I/61m+DPVikjL._UL1500_.jpg",
    ],
    review: [
      "Simply super and value for money deal. Fits well as well and the cut in the sides look very nice. Loved it. Ordering more in other colors. 5 star rating. ",
      "Good quality polo from allen solly....got it for 449 rupees....i read so many reviews which says fake product...but this one is original...comfort is also good...i really liked it.... ",
      "Allen solly is always my fav brand because of fabic fitting n all ",
      "Very good quality and fittings.",
    ],
  },
  {
    catogeries: "fashion",
    id: "19",
    name: "Allen Solly",
    rating: "4.4",
    discription:
      "Care Instructions: Wash with mild detergent, do not bleach, dry in shade Fit Type: regular fit 60% cotton and 40% polyester Regular fit ",
    price: "₹1900",
    image: [
      "https://m.media-amazon.com/images/I/81L9f1n4pGL._AC_UL480_FMwebp_QL65_.jpg",
      "https://m.media-amazon.com/images/I/815gwYhkSsL._UL1500_.jpg",
      "https://m.media-amazon.com/images/I/81AVU5fILpL._UL1500_.jpg",
      "https://m.media-amazon.com/images/I/71gs2X5fZFL._UL1500_.jpg",
    ],
    review: [
      "Simply super and value for money deal. Fits well as well and the cut in the sides look very nice. Loved it. Ordering more in other colors. 5 star rating. ",
      "Good quality polo from allen solly....got it for 449 rupees....i read so many reviews which says fake product...but this one is original...comfort is also good...i really liked it.... ",
      "Allen solly is always my fav brand because of fabic fitting n all ",
      "Very good quality and fittings.",
    ],
  },
  {
    catogeries: "Sports",
    id: "20",
    name: "CEAT POPLAR WILLOW CRICKET BAT (No- 6) Poplar Willow Cricket Bat  (0.900 g) ",
    rating: "3.6",
    discription:
      "Advanced, Training, Beginner Playing Level Bat Grade: Grade 3 Sport Type: Cricket Weight Range 0.900 g",
    price: "₹305",

    image: [
      "https://rukminim1.flixcart.com/image/416/416/jvqzo280/bat/q/b/a/0-900-poplar-willow-cricket-bat-no-6-6-1-ceat-original-imafggjgczcwszky.jpeg?q=70",
      "https://rukminim1.flixcart.com/image/416/416/jvqzo280/bat/q/b/a/0-900-poplar-willow-cricket-bat-no-6-6-1-ceat-original-imafgjxgp4uhyz4y.jpeg?q=70",
      "https://rukminim1.flixcart.com/image/416/416/k2m6ufk0/bat/q/a/r/1160-1220-short-handle-sikander-1000-cb-1149-sh-spartan-original-imafkfvahbp7scbx.jpeg?q=70",
      "https://rukminim1.flixcart.com/image/416/416/jvqzo280/bat/q/b/a/0-900-poplar-willow-cricket-bat-no-6-6-1-ceat-original-imafggjgczcwszky.jpeg?q=70",
    ],

    review: [
      "Super and nice bat . Worth the money . And very light weight Thanks to flip kart.",
      "This bat is very super it is for only 11 to 15 this is very strong also I love this bat this bat is very no cost only 3 45 rupees only",
      "Great bat",
    ],
  },
  {
    catogeries: "fashion",
    id: "69",
    name: "T-shirt Truck Developer Tshirts Printed T-Shirt for Men & Women",
    rating: "5",
    discription:
      "Care Instructions: Wash with mild detergent, do not bleach, dry in shade Fit Type: regular fit 60% cotton and 40% polyester Regular fit ",
    price: "₹499",
    image: [
      "https://m.media-amazon.com/images/I/31HyfPlp+FL.jpg",
      "https://m.media-amazon.com/images/I/31pc2Dc8EAL.jpg",
      "https://m.media-amazon.com/images/I/71ChKRO9+IL._UL1280_.jpg",
      "https://m.media-amazon.com/images/I/41eD82r6DAL.jpg",
    ],
    review: [
      "Simply super and value for money deal. Fits well as well and the cut in the sides look very nice. Loved it. Ordering more in other colors. 5 star rating. ",
      "Good quality polo from allen solly....got it for 449 rupees....i read so many reviews which says fake product...but this one is original...comfort is also good...i really liked it.... ",
      "Allen solly is always my fav brand because of fabic fitting n all ",
      "Very good quality and fittings.",
    ],
  },

  {
    catogeries: "Sports",
    id: "21",
    name: "JetFire Regular Wicket Keeping Gloves Combo With Inner Gloves(Men, Blue) Wicket Keeping Gloves  (Blue) ",
    rating: "4.0",
    discription:
      "Made from high quality PVC cuffs Rubber grip on the front face of the Glove Cloth lining in the cuffs Color May Vary Ideal for Beginners & Above",
    price: "₹584",

    image: [
      "https://rukminim1.flixcart.com/image/416/416/jx502vk0/sport-glove/c/u/q/left-right-college-wicket-keeping-gloves-combo-with-inner-gloves-original-imafhmyzeyvphgzn.jpeg?q=70",
      "https://rukminim1.flixcart.com/image/416/416/jzlldow0/sport-glove/f/d/f/left-right-regular-wicket-keeping-gloves-combo-with-inner-gloves-original-imafhmynjumq637j.jpeg?q=70",
      "https://rukminim1.flixcart.com/image/416/416/jx502vk0/sport-glove/c/u/q/left-right-college-wicket-keeping-gloves-combo-with-inner-gloves-original-imafhmyzhpdzwyxz.jpeg?q=70",
      "https://rukminim1.flixcart.com/image/416/416/jx502vk0/sport-glove/c/u/q/left-right-college-wicket-keeping-gloves-combo-with-inner-gloves-original-imafhmyzygyznngh.jpeg?q=70",
    ],

    review: [
      "Best gloves 👍👍 👍",
      "Awsm Gloves 😍😍",
      "Wonderful product just by supherb 👍👌👌 worth of money",
    ],
  },

  {
    catogeries: "Sports",
    id: "22",
    name: "NODENS Cricket Bat Grip, (Multicolour Pack of 6) Mesh Grip  (White, Pack of 6) ",
    rating: "4.1",
    discription:
      "The batsman in the game of cricket has an exceptionally challenging role to play as he is the one who takes the game forward for his team",
    price: "₹279",

    image: [
      "https://rukminim1.flixcart.com/image/416/416/k0bbb0w0/grip/g/f/q/cricket-bat-grip-6-multicolour-pack-of-6-nodens-original-imafjyahuhedgzvw.jpeg?q=70",
      "https://rukminim1.flixcart.com/image/416/416/k0bbb0w0/grip/g/f/q/cricket-bat-grip-6-multicolour-pack-of-6-nodens-original-imafjyahe8gs9hmt.jpeg?q=70",
      "https://rukminim1.flixcart.com/image/416/416/k0463rk0/grip/t/s/j/cricket-bat-grip-multicolour-pack-of-6-6-cricket-bat-grip-nodens-original-imafjyzfsed6ag29.jpeg?q=70",
      "https://rukminim1.flixcart.com/image/416/416/k0bbb0w0/grip/g/f/q/cricket-bat-grip-6-multicolour-pack-of-6-nodens-original-imafjyahuhedgzvw.jpeg?q=70",
    ],

    review: [
      "Nice grip but which is I ordered ... I not get that grip ..... It's different colour.... ",
      "Very good osm",
      "Nice colors",
    ],
  },

  {
    catogeries: "Sports",
    id: "23",
    name: "Aurion Cricket Bag Shoulder Straps Sports Cricket Kit Bag for 2 Bat Caves with 2 pockets  (Multicolor, Kit Bag)",
    rating: "4.5",
    discription:
      "Cricket Easy zip opening access Straps for easy transportability Padded Adjustable Shoulder Straps & Hanger Multiple External Pockets 2 Bat Caves, One front pocket one main compartment",
    price: "₹449",

    image: [
      "https://rukminim1.flixcart.com/image/416/416/knxiavk0/sport-bag/0/g/m/40-l-cricket-bag-shoulder-straps-sports-cricket-kit-bag-for-2-original-imag2hwraj2kcukq.jpeg?q=70",
      "https://rukminim1.flixcart.com/image/416/416/knxiavk0/sport-bag/t/3/u/40-l-cricket-bag-shoulder-straps-sports-cricket-kit-bag-for-2-original-imag2hwrf3qggbx2.jpeg?q=70",
      "https://rukminim1.flixcart.com/image/416/416/knxiavk0/sport-bag/r/f/k/40-l-cricket-bag-shoulder-straps-sports-cricket-kit-bag-for-2-original-imag2hwrzecfbz6s.jpeg?q=70",
      "https://rukminim1.flixcart.com/image/416/416/knxiavk0/sport-bag/9/e/o/40-l-cricket-bag-shoulder-straps-sports-cricket-kit-bag-for-2-original-imag2hwrz9yza2zb.jpeg?q=70",
    ],

    review: [
      "super ",
      "Nice bag with enough space and above all its material quality is excellent... Go for it...t",
      "Really super product",
    ],
  },

  {
    catogeries: "Sports",
    id: "24",
    name: "SBM  Cricket Ball (Pack Of 12) Cricket Ball  (Pack of 12, Green) ",
    rating: "3.7",
    discription: "Cricket Ball Green Pack Of 12",
    price: "₹339",

    image: [
      "https://rukminim1.flixcart.com/image/416/416/jwpa8i80/ball/p/t/h/160-180-standard-7-35-adrenex-prime-leather-ball-red-1-lbfksg2-original-imafhbz4kgjjeyub.jpeg?q=70",
      "https://rukminim1.flixcart.com/image/416/416/jwpa8i80/ball/p/t/h/160-180-standard-7-35-adrenex-prime-leather-ball-red-1-lbfksg2-original-imafhbz46nhajzhk.jpeg?q=70   ",
      "https://rukminim1.flixcart.com/image/416/416/jwpa8i80/ball/5/6/8/160-180-standard-7-25-adrenex-prime-leather-ball-red-1-lbfksg4-original-imafhbz4e8upz68s.jpeg?q=70",
      "https://rukminim1.flixcart.com/image/416/416/jwpa8i80/ball/p/t/h/160-180-standard-7-35-adrenex-prime-leather-ball-red-1-lbfksg2-original-imafhbz4ffkyqem7.jpeg?q=70",
    ],

    review: [
      "every good product nice ball good puality ",
      "just ok for practice but not for playing matches",
      "Great picture quality, easy to setup. Simply Mindblowing",
    ],
  },
  {
    catogeries: "Sports",
    id: "25",
    name: "NIVIA Storm Football - Size: 5",
    rating: "4.4",
    discription:
      "Playing a sport like football helps the players strengthen team spirit and the same time keeps them fit. This Nivia Storm Football - 5 allows you to play a few matches with friends or colleagues when you have free time. Offers optimum response and feel",
    price: "₹379",

    image: [
      "https://rukminim1.flixcart.com/image/416/416/jxqfonk0/kit/3/3/r/football-training-kit-kit2-nivia-original-imaf42fyevkzq8hz.jpeg?q=70",
      "https://rukminim1.flixcart.com/image/416/416/kjkbv680-0/ball/s/o/g/420-470-storm-22-5-1-niviafb354-football-nivia-original-imafz3uzeht5wgmt.jpeg?q=70",
      "https://rukminim1.flixcart.com/image/416/416/kjkbv680-0/ball/s/5/e/420-470-storm-22-5-1-niviafb354-football-nivia-original-imafz3uz6qf4fzmm.jpeg?q=70",
      "https://rukminim1.flixcart.com/image/416/416/kjkbv680-0/ball/9/n/k/420-470-storm-22-5-1-niviafb354-football-nivia-original-imafz3uzhjhz4khg.jpeg?q=70",
    ],

    review: [
      "The ball was quite good but is somewhat hard to play and the color was awesome I ordered in Flipkart for first time they gave their best and ekart delivered the ball at 12:30 am they did it correctly on time",
      "More delighted to play with little hard rubber made ball. Good graffiti designed so looks great. Totally satisfied with it & I will recommend to others because good product in affordable range.",
      "I got it today. Like it. Very nice good quality football. You must buy it. Thank you flipkart and nivia.",
    ],
  },
  {
    catogeries: "Sports",
    id: "26",
    name: "COSCO HI-GRIP Basketball - Size: 7",
    rating: "4.7",
    discription: "Cricket Ball Green Pack Of 12",
    price: "₹616",

    image: [
      "https://rukminim1.flixcart.com/image/416/416/klscivk0/ball/v/v/b/550-7-hi-grip-13018-basketball-cosco-original-imagytvdbxays3z2.jpeg?q=70",
      "https://rukminim1.flixcart.com/image/416/416/kj1r53k0-0/ball/7/a/t/260-280-hi-grip-s-6-basketball-size-6-pack-of-1-orange-6-24-1-hi-original-imafypdxghzzvdks.jpeg?q=70",
      "https://rukminim1.flixcart.com/image/416/416/kj1r53k0-0/ball/t/e/n/260-280-hi-grip-s-6-basketball-size-6-pack-of-1-orange-6-24-1-hi-original-imafypdxvwgwkcbv.jpeg?q=70",
    ],

    review: [
      "Awesome grip. It Was really cool that I got this cosco's ball in pretty less bugget. Love u flipkart",
      "Very good product and good quality",
      "Happy with the quality and fast delivery",
    ],
  },
  {
    catogeries: "Sports",
    id: "27",
    name: "LI-NING Windstorm Nano 73 Professional Badminton Racquet",
    rating: "3.9",
    discription:
      "Lightweight just got a new word in the dictionary and its the Li-Ning windstorm series. The Windstorm technology included in the Windstorm Nano 73 delivers a feather-like 73-gram weight and makes this racket flag bearer of speed and control. ",
    price: "₹8,990",

    image: [
      "https://rukminim1.flixcart.com/image/416/416/kfa0b680/racquet/8/v/2/g4-3-25-inches-unstrung-windstorm-nano-73-professional-badminton-original-imafvsy4ccvg7gtc.jpeg?q=70",
      "https://rukminim1.flixcart.com/image/416/416/kfa0b680/racquet/8/v/2/g4-3-25-inches-unstrung-windstorm-nano-73-professional-badminton-original-imafvsy4yghtspm7.jpeg?q=70",
      "https://rukminim1.flixcart.com/image/416/416/kfa0b680/racquet/8/v/2/g4-3-25-inches-unstrung-windstorm-nano-73-professional-badminton-original-imafvsy4m4gueymp.jpeg?q=70",
    ],

    review: [
      "every good product nice ball good puality ",
      "just ok for practice but not for playing matches",
      "Great picture quality, easy to setup. Simply Mindblowing",
    ],
  },
  {
    catogeries: "fashion",
    id: "28",
    name: "Classic Polo Men's Regular Fit",
    rating: "4.4",
    discription:
      "Classic Polo Men's Regular Fit Polo T-Shirt (B07YYGMTZM_Purple, Violet_XXXX-Large)Classic Polo Men's Regular Fit Polo T-Shirt (B07YYGMTZM_Purple, Violet_XXXX-Large)",
    price: "₹1800",
    image: [
      "https://m.media-amazon.com/images/I/81NGSl3bGvL._UL1500_.jpg",
      "https://m.media-amazon.com/images/I/81c+BcygzmL._UL1500_.jpg",
      "https://m.media-amazon.com/images/I/81ZZfHwe9lL._UL1500_.jpg",
      "https://m.media-amazon.com/images/I/81EIbMUEhVL._UL1500_.jpg",
    ],
    review: [
      "Simply super and value for money deal. Fits well as well and the cut in the sides look very nice. Loved it. Ordering more in other colors. 5 star rating. ",
      "Excellent in fitting color little dull ",
      "Awesome...... This product fired to me as I expected........",
      " Good ",
    ],
  },
  {
    catogeries: "fashion",
    id: "29",
    name: "Benetton Men's Slim Polo Shirt",
    rating: "4.2",
    discription:
      "United Colors of Benetton Men's Slim Polo Shirt (3081J7107I_RED XL) United Colors of Benetton Men's Slim Polo Shirt",
    price: "₹1500",
    image: [
      "https://images-na.ssl-images-amazon.com/images/I/81XSu2qqGvL._UX466_.jpg",
      "https://m.media-amazon.com/images/I/81A2WhfqG-L._UL1500_.jpg",
      "https://m.media-amazon.com/images/I/814LFcn0EYL._UL1500_.jpg",
      "https://m.media-amazon.com/images/I/71kJZst7-nL._UL1500_.jpg",
    ],
    review: [
      "Simply super and value for money deal. Fits well as well and the cut in the sides look very nice. Loved it. Ordering more in other colors. 5 star rating. ",
      " love it. Very nice product. ",
      "Best quality ever",
      "Got both colors as shown in the image, the seam is neat and strong, Fit is also perfect, and as the caption says, the fabric is really soft but not thin, which is great in my opinion, I got it at a discounted price from MRP so it's a steal! Thanks Wear Your Opinion ",
    ],
  },
  
  {
    catogeries: "fashion",
    id: "30",
    name: "GODFREY Cotton Polo",
    rating: "4.1",
    discription:
      "GODFREY Cotton Polo Neck Half Sleeve Mens T Shirt Size - Small (S / 36)",
    price: "₹1300",
    image: [
      "https://images-na.ssl-images-amazon.com/images/I/71WtmkxWXbS._UY741_.jpg",
      "https://m.media-amazon.com/images/I/81XsDwxALGS._UL1500_.jpg",
      "https://m.media-amazon.com/images/I/71PFg9KqM6S._UL1500_.jpg",
      "https://m.media-amazon.com/images/I/71hXi3t4lzS._UL1500_.jpg",
    ],
    review: [
      "Built quality and stitches are perfect. Looks decent, overall perfect for regular office wear. ",
      "Perfect elegant look. I am totaly satisfied with product. Good quality. After 5 washes also it is still with same shine. Impressed with quality ",
      "Good Product. Colour is awesome",
      "Good quality material, fit as expected and soft fabric. Satisfied with the quality.",
    ],
  },
  
  {
    catogeries: "fashion",
    id: "31",
    name: "Adidas Men's Drogo M Running Shoes",
    rating: "3.4",
    discription:
      "Closure: Lace-Up Shoe Width: Medium Material Type: Mesh Lifestyle: Sports Closure Type: Lace-Up",
    price: "₹4900",
    image: [
      "https://m.media-amazon.com/images/I/81foDd-vw0L._AC_UL480_FMwebp_QL65_.jpg",
      "https://m.media-amazon.com/images/I/71s3dnOiZrL._UL1500_.jpg",
      "https://m.media-amazon.com/images/I/71YJqNNvG-L._UL1500_.jpg",
      "https://m.media-amazon.com/images/I/71Z2a72XwzL._UL1500_.jpg",
    ],
    review: [
      "Base of shoe is having good quality very lightweight to use ",
      "Got it during great indian sale with the offer.Quality looks good.very comfortable.cant comment on reliability without usage .Looks original ,Bar codes did work.Didn't feel confident while doing sprint or fast runs ,as it is extremely light weight.",
      "The product seems nice and genuine! A good quality product with good quality packing by. Great job Amazon...",
      "Good Quality ",
    ],
  },
  {
    catogeries: "fashion",
    id: "32",
    name: "Reebok Men's Fast Motion ",
    rating: "4.1",
    discription:
      "Reebok Men's Fast Motion Run Lp Shoe Reebok Men's Fast Motion Run Lp Shoe",
    price: "₹3900",
    image: [
      "https://images-na.ssl-images-amazon.com/images/I/71NRk6xv7-S._UL1500_.jpg",
      "https://m.media-amazon.com/images/I/719ehdzCz-S._UL1500_.jpg",
      "https://m.media-amazon.com/images/I/71Yh+3Lr5MS._UL1282_.jpg",
      "https://m.media-amazon.com/images/I/71mAVSpieOS._UL1500_.jpg",
    ],
    review: [
      "Using it for running/walking on different surfaces like concrete, uneven terrain, etc, and it does a great job by providing enough cushioning for my feet. Definitely recommend. ",
      "Shoes was flexible to run & really it was a fabulous product...please go for it",
      "very vice and comfort and resonable price ",
      " It's color and design is as same as in pictures and the fitting is good but the pasting of the product is not so much good. It's appearing to be 1st copy according to pasting.",
    ],
  },
  {
    catogeries: "fashion",
    id: "33",
    name: "Navy Running Shoes-6 UK",
    rating: "4.2",
    discription:
      "FURO by Redchief Men Navy Running Shoes-6 UK (40 EU) (R1013 C585_6) FURO by Redchief Men Navy Running Shoes-6 UK (40 EU) (R1013 C585_6)",
    price: "₹2900",
    image: [
      "https://m.media-amazon.com/images/I/61ka6aqLRqL._UL1440_.jpg",
      "https://m.media-amazon.com/images/I/71huRQQhouL._UL1440_.jpg",
      "https://m.media-amazon.com/images/I/610ir8rXf4L._UL1440_.jpg",
      "https://m.media-amazon.com/images/I/610+Aq+6qwL._UL1440_.jpg",
    ],
    review: [
      "Good same as like ",
      "Hat's off to redchief once again for such a mesmerizing product. Great quality and and worth the money spent.Looks and texture may leave you open eyed.Looking forward for redchief amzon combo in future. ",
      "Superb ... Best gift to my dear friend...",
      "Good product and it is delivered early. ",
    ],
  },
  {
    catogeries: "fashion",
    id: "34",
    name: "Ray-Ban Men Square Sunglasses",
    rating: "4.4",
    discription:
      "Model Number 601S71 Part Number: 601S71 Frame Color:Black , Lens Color: Green Frame type:Full Rim, Lens type:Non polarized Frame Material: Composite Lens Width : 56 mm Bridge Width : 20 mm Temple Length : 145 mm",
    price: "₹3000",
    image: [
      "https://images-na.ssl-images-amazon.com/images/I/61CobOBk6cL._UL1500_.jpg",
      "https://m.media-amazon.com/images/I/51fxHWzCqES._UL1500_.jpg",
      "https://m.media-amazon.com/images/I/51SJSQEuSOS._UL1500_.jpg",
      "https://m.media-amazon.com/images/I/51gqpuiOinS._UL1500_.jpg",
    ],
    review: [
      "Its rayban....what more to say about comfortness.",
      "Same as description, original labels and hologram available. ",
      "Good one, I got it for Amazon lightening deal. Its a genuine Ray-Ban, great quality, looks are descent but was a bit oversized. ",
      "Its nice if you like the black shade! ",
    ],
  },
  {
    catogeries: "Beauty and Cosmetics",
    id: "35",
    name: "NIVEA Soft Moisturizing Cream  (200 ml)",
    rating: "4.5",
    discription:
      "Get smooth and radiant skin by using this Nivea Moisturiser. This cream suits almost all skin types.Enriched with the goodness of vitamin E and Jojoba oil, this cream gently moisturizes your skin, leaving it soft and supple.",
    price: "₹233",

    image: [
      "https://rukminim1.flixcart.com/image/416/416/kiow6fk0/combo-kit/z/g/d/body-milk-nourishing-lotion-600-ml-soft-light-moisturiser-100-ml-original-imafyf68fxskcznz.jpeg?q=70",
      "https://rukminim1.flixcart.com/image/416/416/kiow6fk0/moisturizer-cream/n/g/s/300-soft-moisturizing-cream-cream-nivea-original-imafyf68v2yhmyys.jpeg?q=70",
      "https://rukminim1.flixcart.com/image/416/416/kiow6fk0/moisturizer-cream/n/g/s/300-soft-moisturizing-cream-cream-nivea-original-imafyf68hzvhf24z.jpeg?q=70",
      "https://rukminim1.flixcart.com/image/416/416/kiow6fk0/moisturizer-cream/n/g/s/300-soft-moisturizing-cream-cream-nivea-original-imafyf68jjesn6zq.jpeg?q=70",
    ],
    review: [
      "This is one of the most hydrating cream. Can be used before makeup as well. Gives a tender fragrance and has a great texture It has a good packing and quick delivery.",
      "This has been a necessity now of my daily routine. I prefer this light moisturizer more than any fantasy cream out there in the market. Affordable and gets your face hydrated throughout. Best suitable for every skin type and don't expect this cream to make you fair or make you look like a star but one thing I can guarantee you is that it will make your skin soft and shooting to touch.",
      "I like the Moisturizer..The biggest thing is that the market price is 299 and 223 in Flipkart is a great thing.. So I'm happy to shop with Flipkart..",
      "Love you Nivea for this Soft Moisturizer. This is Suitable for Dry skin, Can be used as Face cream as Well as Cold cream. Iam loving it ",
    ],
  },
  {
    catogeries: "Beauty and Cosmetics",
    id: "36",
    name: "DOVE Intense Repair Conditioner  (175 ml)",
    rating: "4.4",
    discription:
      "Beautiful and healthy hair is just a wash away. This conditioner gently repairs the signs of damage by penetrating deep into the hair strands and provides nourished and strong hair.It deeply penetrates into the hair and strengthens them, reducing damage.",
    price: "₹125",

    image: [
      "https://rukminim1.flixcart.com/image/416/416/krz97rk0/conditioner/y/q/7/intense-repair-conditioner-dove-original-imag5nknhe7zevmf.jpeg?q=70",
      "https://rukminim1.flixcart.com/image/416/416/krz97rk0/conditioner/l/q/t/intense-repair-conditioner-dove-original-imag5nknhzyga9hv.jpeg?q=70",
      "https://rukminim1.flixcart.com/image/416/416/krz97rk0/shampoo/r/c/s/intense-repair-shampoo-dove-original-imag5nkkkhntseth.jpeg?q=70",
      "https://rukminim1.flixcart.com/image/416/416/krz97rk0/conditioner/c/j/8/daily-shine-conditioner-dove-original-imag5nkjsezpavre.jpeg?q=70",
    ],
    review: [
      "Good product I got this product one-day earlier! Using this product my hair is so manageable ,frizz free,and all the claims offered by the dove company is true .Thanks Filpkart for the fast delivery .",
      "The packaging was good and the product is good as I've used it earlier as well..got it in only 123/- amazing deal..",
      "i always love dove range. and its amazingly delivered by the seller without any defect.",
      "This shampoo was really good after three days of wash.it feels like today i washed my hairs...i love to.buy it again.",
    ],
  },
  {
    catogeries: "Beauty and Cosmetics",
    id: "37",
    name: "Clean & Clear Face Wash  (450 ml)",
    rating: "4.5",
    discription:
      "Clean & Clear Foaming Face Wash helps prevent oily skin and pimples. Its rich foam gently cleanses to remove dirt without drying your skin. It is specially designed unique formulation cleanses skin thoroughly preventing common skin problems. Gentle enough to use every day, it leaves your skin feeling clean and beautifully clear.",
    price: "₹346",

    image: [
      "https://rukminim1.flixcart.com/image/416/416/kjkbv680-0/face-wash/l/r/7/450-face-wash-clean-clear-original-imafz3hz4fgwhfnf.jpeg?q=70",
      "https://rukminim1.flixcart.com/image/416/416/kg5fzww0hlty2aw-0/face-wash/3/g/y/foaming-face-wash-clean-clear-original-imafwgjycfbzapb2.jpeg?q=70",
      "https://rukminim1.flixcart.com/image/416/416/kg5fzww0hlty2aw-0/face-wash/g/r/0/foaming-face-wash-clean-clear-original-imafwgkfvznkq3zu.jpeg?q=70",
      "https://rukminim1.flixcart.com/image/416/416/kg5fzww0hlty2aw-0/face-wash/f/5/f/foaming-face-wash-clean-clear-original-imafwgkfqcyvz7ng.jpeg?q=70",
    ],
    review: [
      "It is awesome blossom. No damage , quality and quantity all is good. Clean and clear face wash is the best face wash ever and i have been using from 10 years. This face wash have not harmful chemicals. is the best for oily skin. Don't be think anything take it.",
      "This Face is superb although could be little more cheaper but although good stuff for daily use...In one word just refreshing",
      "Best face wash in market, go ahead and it is suitable for all skin types. Makes you feel clean and clear",
      "It gives naturally soft smooth skin. It also works on normal to dry skin during summer; my skin never lost its natural nourishment. Now coming to the brightness part, yes it makes skin bright by removing the dullness from the face. My skin looks fresh and totally clear, so overall it looks very bright.",
    ],
  },
  {
    catogeries: "Beauty and Cosmetics",
    id: "38",
    name: "Kesh King Scalp and Medicinal Ayurvedic Hair Oil  (100 ml)",
    rating: "4.3",
    discription:
      "Kesh King ayurvedic oil is a proprietary medicinal preparation without any side effects. It is a complete solution for hair related problems especially hair fall. It is prepared using tel pak vidhi as prescribed in ayurveda using 21 precious herbs cooked in sesame oil",
    price: "₹144",

    image: [
      "https://rukminim1.flixcart.com/image/416/416/jwtkk280/hair-oil/g/f/v/100-scalp-and-hair-medicine-oil-100-ml-kesh-king-original-imafhf7fu3nhgzng.jpeg?q=70",
      "https://rukminim1.flixcart.com/image/416/416/jwtkk280/hair-oil/g/f/v/100-scalp-and-hair-medicine-oil-100-ml-kesh-king-original-imafhf6pwzgyyfmp.jpeg?q=70",
    ],
    review: [
      "Excellent Service by flipkart in lockdown situation genuine products love it ❤️ fast delivery",
      "timely delivered. original product",
      "Great Flipkart like alway. thanks Flipkart. MRP IS 320 but gave in 257. superb",
      "Excellent product for reducing hair fall. the effect starts after few weeks of use",
    ],
  },
  {
    catogeries: "Beauty and Cosmetics",
    id: "39",
    name: "SET WET Cool, Charm and Swag Avatar Deodorant Spray - For Men  (450 ml, Pack of 3)",
    rating: "4.2",
    discription:
      " Kickstart your day with the masculine and refreshing fragrances of this Set Wet deo set. It contains the Set Wet Cool Avatar, Charm Avatar and Swag Avatar. Spritz on a few drops of any deo from this pack according to your mood and get ready to take on the world.",
    price: "₹287",

    image: [
      "https://rukminim1.flixcart.com/image/416/416/jvtujrk0/deodorant/d/k/k/450-cool-charm-and-swag-avatar-deodorant-spray-set-wet-men-original-imafghmhghggfsgj.jpeg?q=70",
      "https://rukminim1.flixcart.com/image/416/416/jvv9zm80/deodorant/d/k/k/450-cool-charm-and-swag-avatar-deodorant-spray-set-wet-men-original-imafghmhn4ht325r.jpeg?q=70",
      "https://rukminim1.flixcart.com/image/416/416/jvv9zm80/deodorant/d/k/k/450-cool-charm-and-swag-avatar-deodorant-spray-set-wet-men-original-imafghmhnq4gyhut.jpeg?q=70",
    ],
    review: [
      "good purchase but I am not satisfied with the product.there smell doesn't stay for long time and the charm and cool avatar, both have same fragrance.At last I want to say that I am not satisfied with the product....hope this information is useful for others.",
      "Good product.... Charm and cool best for men and swag for girl........ 👌👌👌Best price..",
      "I got it for just 177 so, never believed it to be genuine but it's original and it's really good. Cool and charm are refreshing and have mild smell. The Swag one is kind of fruity and strong smell and it's unique, feels more like a perfume than deodorant.",
      "actually i dont like this deodorant .......but i want to say something that ......if u dont have money to buy any good deo this is best for you. i recommend if u have more budjet then buy code perfume that is awesome.",
    ],
  },
  {
    catogeries: "Beauty and Cosmetics",
    id: "40",
    name: "BOROPLUS Antiseptic + Moisturising Soap - Neem, Eucalyptus & Honey  (6 x 125 g)",
    rating: "4.4",
    discription:
      "BoroPlus Antiseptic + Moisturising Soap Neem, Eucalyptus & Honey Kills 99.99% Germs^ and Kills Virus* Softens and Moisturises Skin From Indias No. 1 Antiseptic# Brand Recommended by Doctors Gives Healthy Skin Enriched with Antiseptic & Healing Power of Neem & Eucalyptus Moisturising power of Honey Protects your entire family Free from Paraben, Silicones and Artificial colorants Anti-bacterial Toilet soap: Grade 1. TFM 76%",
    price: "₹197",

    image: [
      "https://rukminim1.flixcart.com/image/416/416/kfeamq80/soap/r/v/h/6-780-antiseptic-moisturising-soap-neem-eucalyptus-honey-pack-of-original-imafvvetamses4fg.jpeg?q=70",
      "https://rukminim1.flixcart.com/image/416/416/kfeamq80/soap/r/v/h/6-780-antiseptic-moisturising-soap-neem-eucalyptus-honey-pack-of-original-imafvvetgzg5nzq3.jpeg?q=70",
      "https://rukminim1.flixcart.com/image/416/416/kfeamq80/soap/r/v/h/6-780-antiseptic-moisturising-soap-neem-eucalyptus-honey-pack-of-original-imafvvetnbukh7ha.jpeg?q=70",
    ],
    review: [
      "I am very happy with this soap. All the time my washroom is full of good fragrance because of it. Also it lasts long. Very good for summer I think",
      "VERY IMPRESSIVE PRODUCT FROM BORO PLUS",
      "Nice fragrance. You should be try once and then you will be addicted for this product. Blindly go for it. Value for money. Thanks",
      "Awesome deal... Fragrance of this is very fantastic... recommended...",
    ],
  },
  {
    catogeries: "Beauty and Cosmetics",
    id: "41",
    name: "FOGG 1 Royal and 1 Napoleon Deodorant Combo Pack of 2 Deodorant Spray - For Men  (300 ml, Pack of 2)",
    rating: "4.3",
    discription:
      "This Status fragrance body spray from Fogg is a power packed deodorant that offers more than you bargain for. This perfumed body spray has an invigorating scent which envelops you in a pleasant smell for a long time.",
    price: "₹197",

    image: [
      "https://rukminim1.flixcart.com/image/416/416/kj4m0sw0-0/deodorant/q/n/7/300-1-royal-and-1-napoleon-deodorant-combo-pack-of-2-deodorant-original-imafyrcceg565zmf.jpeg?q=70",
    ],
    review: [
      "first thing is tht delivery was soo fast thanks for the flipkart for tht n the product is good with a good packing i wl suggest go for it blindly.....",
      "Excellent Product & Filpkart is Best ever Fastest Delivery 100% Genuine ! thank you",
      "The product is just Awesome. It has an awesome flowery kind of smell. I liked both but the red one is my personal favourite. Product got delivered in just 2 days. Thanks to Flipkart for such awesome service.😎",
      "Nice deodorant with good fragrance. It stays full day. I like it. Thanks flipkart for the good deal.",
    ],
  },
  {
    catogeries: "Beauty and Cosmetics",
    id: "42",
    name: "GARNIER Skin Naturals Bright Complete Brightening Face Wash  (200 g)",
    rating: "4.5",
    discription:
      "Garnier Bright Complete is a womens facewash enriched with Yuzu Lemon essence. Yuzu Lemon is known as the King of Lemons since it contains a high concentration of Vitamin C and is known for its strong brightening, exfoliating and anti-oxidant properties. ",
    price: "₹236",

    image: [
      "https://rukminim1.flixcart.com/image/416/416/ko8xtow0/face-wash/c/f/o/skin-naturals-bright-complete-brightening-face-wash-garnier-original-imag2qyq23wccmhu.jpeg?q=70",
      "https://rukminim1.flixcart.com/image/416/416/ko8xtow0/face-wash/6/d/n/skin-naturals-bright-complete-brightening-face-wash-garnier-original-imag2qyqehjg3ayu.jpeg?q=70",
      "https://rukminim1.flixcart.com/image/416/416/ko8xtow0/face-wash/0/u/p/skin-naturals-bright-complete-brightening-face-wash-garnier-original-imag2qyqbzvuv6we.jpeg?q=70",
      "https://rukminim1.flixcart.com/image/416/416/ko8xtow0/face-wash/6/g/y/skin-naturals-bright-complete-brightening-face-wash-garnier-original-imag2qyqtbahdnmt.jpeg?q=70",
    ],
    review: [
      "Yes it is very nice and gives smoother skin with lite lighten fairness on daily basis use thank u Flipkart and thank u Ravi for u r polite delivery from ekart logistics",
      "Nice face wash you will get best result when u use garnier cream with it ...all in all i like this facewash",
      "Good price and good deal. Effective gave wash and its suitable for all skin types.",
      "Best facewash which I found ever. This makes my face clear and beautiful essence which last for atleast 6 hours. You must go for it.",
    ],
  },
  {
    catogeries: "phone",
    id: "43",
    name: "OnePlus Nord 2 5G (Gray Sierra, 8GB RAM, 128GB Storage)",
    rating: "4.8",
    discription:
      "OnePlus Nord 2 5G (Gray Sierra, 8GB RAM, 128GB Storage) features a stylish design and innovative features so that you can enjoy using the mobile phone for all that you need. Thanks to its 6000 mAh battery, you will have a blast using your phone for a long time while you stream content and much more. It provides surround sound with Dolby Atmos so that you can delve into a world of rich music. And, it’s equipped with features that ensure the protection of your mobile phone.",
    price: "₹29900",
    image: [
      "https://m.media-amazon.com/images/I/71LRBr1aLNS._SL1500_.jpg",
      "https://m.media-amazon.com/images/I/61TnX0PmqES._AC_SS450_.jpg",
      "https://cdn.pocket-lint.com/r/s/1200x/assets/images/157747-phones-review-hands-on-oneplus-nord-2-review-image11-8sxrpujdtq.jpg",
    ],
    review: [
      `
      Pros:
      1. Very ultra premium features at this price range of 30k and pretty much matching features with higer range one plus models.
      2. The display is just great.
      3. Screen refresh rate you can actually feel to be fast @90Hz.
      4. No heating issue in phone or the charger till now.
      5. They are giving a back cover with the phone, which is pretty good actually with bumps in side and camera portion which actually saved my phone from a direct fall on a rough floor that too on screen side..and no scratches at all!!..so the cover's tested guys😂and it actually feels elegant. ,
      "First I would like to thank you Flipkart for fastest delivery and yah the delivery guy is so cooperative and helpful. Samsung phones are always best in performance and this one is also affordable and awesome phone",
       Cons:
      1. They could have provided a little higher battery capacity like those in Samsung phones coz of Such a high resolution display and refresh rate..but it could have increased the weight of phone..so its pretty much understandable.
      Battery back up is some what 12-14 hrs which I got on continuous usage..like songs.. attending meetings on teams.. Netflix etc. But since it gives so..so..so.. fast charging u just wont feel it.

      2. No earphone jack..If that is a con to u..not for me actually😂
      Nothing else serious issue this phone has got me into till now .So that it guys..If i find anything else after prolonged Usage I will honestly put it here.
      So I will say if you wanna buy a phone above 50k just dont..buy this if you budget is ~25k stretch it a lill and buy this Nord 2.
`,
    ],
  },
  {
    catogeries: "phone",
    id: "44",
    name: "Samsung Galaxy M31 (Ocean Blue, 6GB RAM, 128GB Storage)",
    rating: "4.1",
    discription:
      "The Samsung Galaxy M31 features a stylish design and innovative features so that you can enjoy using the mobile phone for all that you need. Thanks to its 6000 mAh battery, you will have a blast using your phone for a long time while you stream content and much more. It provides surround sound with Dolby Atmos so that you can delve into a world of rich music. And, it’s equipped with features that ensure the protection of your mobile phone.",
    price: "₹20900",
    image: [
      "data:image/jpeg;base64,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",
      "data:image/jpeg;base64,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",
      "https://static.toiimg.com/thumb/resizemode-4,msid-71182339,imgsize-200,width-640/71182339.jpg",
    ],
    review: [
      `
      Pros:
     - Android 10! Beautiful looks! Finally I can delete SMS from notification now!!
- Display is excellent with Blue light filter.
- Performance is good. No heating or lagging. Real Racing worked fine.
- 6000 Mah battery is BIG
- 128 GB storage is pretty good. 512 GB card supported with dedicated external card slot.
- Both dedicated sim slots support LTE
- Fast charging and 15W charger top with phone. The phone came with 0% charge. Charged fast.
- Mobile speakers sound is good, but I prefer external speakers for better bass in music.
- Camera is really good. Macro performance is very good - look at skin in tatoo photo and dust perticles in deskphone photo!! (photos of M31 are from other phone). Both front and rear camera support FHD video 3840x2160. I may not require to carry my DSLR everyehere.
- Face unlock / figure-print sensor response is good
- Received next day by 11 AM !
Cons:
 Not that thin, but ok.
- Doesn't have Samsung Dex
- Started to Boot Screen!! Gave me a little shock but selected reboot option and then every thing was smooth. An Android Updated (other than many application updates which is normal in any case) appeared on within days of launch. But update was smooth. No issue at all.
- Feels delicate in hand but a Rs.49 cover was good enough. Wrongly ordered black while the set is blue. Just 49 so will reorder the blue one as well :)
- Called Samsung Store, but no information with them about availability date. Still no call from them.

Feedback

- Feels good in hand and in use. It is a powerhouse and you feel it.
- Will update after few days of use, but don't have any doubt as of now. (Aug 2021 - excellent, no 
`,
    ],
  },
  {
    catogeries: "Beauty and Cosmetics",
    id: "45",
    name: "Aroma Magic Face Wash 100 ml (Charcoal)",
    rating: "4.8",
    discription:
      "Aroma Magic Face Wash 100 ml (Charcoal) facewash enriched with Yuzu Lemon essence. Yuzu Lemon is known as the King of Lemons since it contains a high concentration of Vitamin C and is known for its strong brightening, exfoliating and anti-oxidant properties. ",
    price: "₹236",

    image: [
      "https://cdn.shopify.com/s/files/1/2801/8342/products/Neem-and-Tea-Tree-Face-Wash-A_1200x.jpg?v=1610107060",
      "https://s3.ap-south-1.amazonaws.com/test-bucket-120/FCWESFHCE5TWVB9Z_image.jpeg",
      "https://m.media-amazon.com/images/I/61-cdODmWuL._SL1200_.jpg",
      "https://m.media-amazon.com/images/I/61-cdODmWuL._SL1200_.jpg",
      "https://m.media-amazon.com/images/I/61DNzmaO4xL._SL1200_.jpg",
    ],
    review: [
      "Yes it is very nice and gives smoother skin with lite lighten fairness on daily basis use thank u Flipkart and thank u Ravi for u r polite delivery from ekart logistics",
      "Nice face wash you will get best result when u use garnier cream with it ...all in all i like this facewash",
      "Good price and good deal. Effective gave wash and its suitable for all skin types.",
      "Best facewash which I found ever. This makes my face clear and beautiful essence which last for atleast 6 hours. You must go for it.",
    ],
  },
  {
    catogeries: "Beauty and Cosmetics",
    id: "46",
    name: "NIVEA Men Face Wash, Deep Impact Intense Clean, for Beard & Face, with Black Carbon, 100 g",
    rating: "4.2",
    discription:
      "NIVEA Men Face Wash Complete is a men facewash enriched with Yuzu Lemon essence. Yuzu Lemon is known as the King of Lemons since it contains a high concentration of Vitamin C and is known for its strong brightening, exfoliating and anti-oxidant properties. ",
    price: "₹256",

    image: [
      "https://res.sastasundar.com/incom/images/product/thumb/Nivea-Men-Deep-Impact-Intense-Clean-Black-Carbon-Face--Beard-Wash-1565424482-10045996-2.jpg",
      "https://rukminim1.flixcart.com/image/416/416/jj0bbm80/face-wash/n/k/m/100-men-deep-impact-intense-clean-black-carbon-face-beard-wash-original-imaf6ne4nsk95vae.jpeg?q=70",
      "https://rukminim1.flixcart.com/image/416/416/kingqkw0pkrrdj-0/facial-care/8/3/q/nv819-nivea-men-original-imafyhjzfsu9xduw.jpeg?q=70",
      "https://images-static.nykaa.com/media/catalog/product/c/c/cc0d85b4005900518217__1_.jpg",
    ],
    review: [
      "Yes it is very nice and gives smoother skin with lite lighten fairness on daily basis use thank u Flipkart and thank u Ravi for u r polite delivery from ekart logistics",
      "Nice face wash you will get best result when u use garnier cream with it ...all in all i like this facewash",
      "Good price and good deal. Effective gave wash and its suitable for all skin types.",
      "Best facewash which I found ever. This makes my face clear and beautiful essence which last for atleast 6 hours. You must go for it.",
    ],
  },
  {
    catogeries: "fashion",
    id: "47",
    name: "Rozior® Kids Sunglass with UV Protection Green Mirror Lens with Black Frame, MODEL: RWUK1028M1",
    rating: "4.4",
    discription:
      "MODEL: RWUK1028M1 || SIZE: Small || FRAME: Glossy Black Poly Carbonate || LENS: Green Mirror AC-Acrylic SUN PROTECTION: Rozior latest UV400 protected lens to block 100% Ultra Violet rays and protect eyes from UVA, UVB, UVC, Blue Light or any kind of harmful sun rays.",
    price: "₹3500",
    image: [
      "https://assetscdn1.paytm.com/images/catalog/product/K/KI/KIDROZIOR-ITALYDR-S839815FA26831F/1614600620368_42.jpg",
      "https://www.rozior.com/media/catalog/product/cache/1/image/9df78eab33525d08d6e5fb8d27136e95/1/_/1_5_21.jpg",
      "https://www.rozior.com/media/catalog/product/cache/1/image/9df78eab33525d08d6e5fb8d27136e95/2/_/2_rozior_sunglasses_kids_rwuk1028m1_main02_2.jpg",
      "https://assetscdn1.paytm.com/images/catalog/product/K/KI/KIDAMOUR-UV-PROVERM111555B1C9ECE5/1602402409527_0..jpg?imwidth=280&impolicy=hq",
    ],
    review: [
      "Its Rozior....what more to say about comfortness.",
      "Same as description, original labels and hologram available. ",
      "Good one, I got it for Amazon lightening deal. Its a genuine Ray-Ban, great quality, looks are descent but was a bit oversized. ",
      "Its nice if you like the black shade! ",
    ],
  },
  {
    catogeries: "fashion",
    id: "48",
    name: "Skeletos Men's Wayfarer Sunglasses (Black Frame, Black Lens)",
    rating: "4.5",
    discription:
      "Comfortable Nose Pads Design - This pair of polarized sunglasses for men with its one-piece nose pads design which will not oppress nose bridge. It will make you more stable and more comfortable to wear Retro Classic Style - Vintage square sunglasses are suitable for any face, show your unique and high-end taste",
    price: "₹3000",
    image: [
      "https://m.media-amazon.com/images/I/315DB2LDQXL.jpg",
      "https://4.imimg.com/data4/RL/TW/MY-35189596/p2-black-500x500.jpg",
      "https://img0.junaroad.com/uiproducts/17499538/zoom_2-1612002915.jpg",
      "https://5.imimg.com/data5/XO/PP/MY-19467740/full-black-mens-wayfarer-sunglasses-500x500.jpg",
    ],
    review: [
      "Its Skeletos...what more to say about comfortness.",
      "Same as description, original labels and hologram available. ",
      "Good one, I got it for Amazon lightening deal. Its a genuine Ray-Ban, great quality, looks are descent but was a bit oversized. ",
      "Its nice if you like the black shade! ",
    ],
  },
  {
    catogeries: "fashion",
    id: "49",
    name: "Campus Men's VIBGYOR Running Shoes",
    rating: "4.3",
    discription:
      "Campus Men Navy Running Shoes-6 UK (40 EU) (R1013 C585_6) Campus f Men Navy Running Shoes-6 UK (40 EU) (R1013 C585_6)",
    price: "₹2990",
    image: [
      "https://rukminim1.flixcart.com/image/714/857/kcm9t3k0/shoe/f/x/b/cg-123-10-campus-full-blk-original-imaftpmkdvekye84.jpeg?q=50",
      "https://rukminim1.flixcart.com/image/714/857/k1b1bbk0/shoe/w/2/y/5g-708-8-campus-navy-wht-original-imafkwx6vmcdq7zz.jpeg?q=50",
      "https://m.media-amazon.com/images/I/41XeFyCxVOS.jpg",
      "https://rukminim1.flixcart.com/image/714/857/kiew3gw0/shoe/p/k/x/11g-749-6-campus-moderate-blu-blk-original-imafy7ft99sebyzc.jpeg?q=50",
    ],
    review: [
      "Good same as like ",
      "Hat's off to redchief once again for such a mesmerizing product. Great quality and and worth the money spent.Looks and texture may leave you open eyed.Looking forward for redchief amzon combo in future. ",
      "Superb ... Best gift to my dear friend...",
      "Good product and it is delivered early. ",
    ],
  },
  {
    catogeries: "fashion",
    id: "50",
    name: "Sparx Men's Running Shoes",
    rating: "4.8",
    discription:
      "Sparks Men Navy Running Shoes-6 UK (40 EU) (R1013 C585_6) Sparks Running Shoes-6 UK (40 EU) (R1013 C585_6)",
    price: "₹2900",
    image: [
      "https://rukminim1.flixcart.com/image/400/400/j9st5zk0/shoe/9/q/f/sm-119-44-sparx-grey-maroon-original-imaezgw3vnuzshdh.jpeg?q=90",
      "https://5.imimg.com/data5/SELLER/Default/2020/10/HD/EJ/VW/78484229/sparx-men-s-running-shoes-500x500.jpg",
      "https://m.media-amazon.com/images/I/71KgHOfYDZL._UL1500_.jpg",
      "https://m.media-amazon.com/images/I/81-VmFJzkQL._UL1500_.jpg",
    ],
    review: [
      "Good same as like ",
      "Hat's off to redchief once again for such a mesmerizing product. Great quality and and worth the money spent.Looks and texture may leave you open eyed.Looking forward for redchief amzon combo in future. ",
      "Superb ... Best gift to my dear friend...",
      "Good product and it is delivered early. ",
    ],
  },
  
];

export default data;
